import type { FC } from 'react';
import React from 'react';
import { createPortal } from 'react-dom';

import useClampedLeft from './useClampedLeft';

interface Props {
  top: number;
  left: number;
  placement: 'top' | 'bottom';
  actionLabel: string;
}

const RephraseLoadingChip: FC<Props> = ({
  top,
  left,
  placement,
  actionLabel,
}) => {
  const { ref, clampedLeft } = useClampedLeft(left);

  return createPortal(
    <div
      ref={ref}
      className="medium-editor-toolbar medium-editor-toolbar-active ai-rephrase-loading-chip"
      style={{
        top,
        left: clampedLeft,
        transform:
          placement === 'top' ? 'translate(-50%, -100%)' : 'translate(-50%, 0)',
      }}
      role="status"
      data-test-id="ai-rephrase-loading"
    >
      <span className="ai-rephrase-spinner" aria-hidden="true" />
      {actionLabel ? `${actionLabel} — rephrasing…` : 'Rephrasing…'}
    </div>,
    document.body,
  );
};

export default RephraseLoadingChip;
